var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCartEmpty = function SvgCartEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4EAE9",
    d: "M68.406 70.5h-50.5a2.531 2.531 0 0 1-2.5-2.219l-4.437-40a2.499 2.499 0 0 1 2.469-2.781h59.437a2.5 2.5 0 0 1 2.469 2.781l-4.438 40a2.531 2.531 0 0 1-2.5 2.219Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F4EAE9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M30.656 35.5v-10a12.5 12.5 0 0 1 25 0v10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#691B33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M65.25 67.5h-50.5a2.532 2.532 0 0 1-2.5-2.219l-4.437-40A2.5 2.5 0 0 1 10.28 22.5H69.72a2.5 2.5 0 0 1 2.469 2.781l-4.438 40a2.532 2.532 0 0 1-2.5 2.219Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#691B33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M27.5 32.5v-10a12.5 12.5 0 0 1 25 0v10"
  })));
};
export default SvgCartEmpty;